const STORAGE_KEY = 'dashboard_last_session_v1';

/**
 * ホーム「前回の続き」用。ダッシュボードで閲覧が成立したタイミングで保存する。
 * @param {object} payload
 * @param {string} payload.action
 * @param {string} [payload.location]
 * @param {string} payload.year
 * @param {string} payload.month
 * @param {string} payload.label
 * @param {'/purpose'|'/function'} payload.dashboard_path
 */
export function saveLastSession(payload) {
  try {
    const record = {
      ...payload,
      timestamp: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch (_) {
    /* ignore quota / private mode */
  }
}

export function loadLastSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

export function useLastSession() {
  return {
    save: saveLastSession,
    load: loadLastSession,
  };
}
